import ReactGA from 'react-ga'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

if (!ReactGA.ga()) {
  ReactGA.initialize('UA-64784451-1')
}

const GoogleAnalytics = () => {
  const { pathname, search } = useLocation()

  useEffect(() => {
    ReactGA.set({
      page: pathname + search,
    })
    ReactGA.pageview(pathname + search)
  }, [pathname, search])

  return <div></div>
}

export default GoogleAnalytics
